import {
    ValgStateActionTypes,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    ValgState,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederSlettingAvRenterAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederSlettingAvRenterAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<VeilederSlettingAvRenterAppState, {}, AnyAction>,
        getState: () => VeilederSlettingAvRenterAppState,
    ): void => {
        const currentState = getState();
        const visInntektOgBarn = visB(currentState);
        const visResultatCa = visCa(currentState);
        const visResultatCb = visCb(currentState);
        dispatch(
            setVisning({
                visInntektOgBarn,
                visResultatCa,
                visResultatCb,
            }),
        );
    };
};

const visB = (state: VeilederSlettingAvRenterAppState): boolean => {
    if(state.valg.bInntektOgBarn === undefined)
        return false;
        
    return state.valg.bInntektOgBarn;
};

const visCa = (state: VeilederSlettingAvRenterAppState): boolean => {
    if(state.satser?.SATS_ST07_Inntektsgrense1Mnd === undefined || state.satser?.SATS_ST07_TilleggAarsinntektRFBarn === undefined || state.valg.cAntallBarn === undefined || state.valg.cInntekt === undefined)
        return false;

    //Hvis B1> [ID81] + ([ID79] x B2)
    let res: number = state.satser?.SATS_ST07_Inntektsgrense1Mnd + (state.satser?.SATS_ST07_TilleggAarsinntektRFBarn * state.valg.cAntallBarn)
    if(state.valg.cInntekt <= res)
        return true;
        
    return false;
};

const visCb = (state: VeilederSlettingAvRenterAppState): boolean => {

    if(state.satser?.SATS_ST07_Inntektsgrense1Mnd === undefined || state.satser?.SATS_ST07_TilleggAarsinntektRFBarn === undefined || state.valg.cAntallBarn === undefined || state.valg.cInntekt === undefined)
        return false;

    //Hvis B1> [ID81] + ([ID79] x B2)
    let res: number = state.satser?.SATS_ST07_Inntektsgrense1Mnd + (state.satser?.SATS_ST07_TilleggAarsinntektRFBarn * state.valg.cAntallBarn)
    if(state.valg.cInntekt > res)
        return true;
        
    return false;
};

